import PageHero from '../components/PageHero';
import { fullServiceDetails } from '../data';
import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function FullService() {
  return (
    <main className="bg-white">
      <SEO 
        title="Full Service Løsninger | Bogføring, Løn & Regnskab – FINANJU"
        description="Outsource din økonomi- og jurafunktion til FINANJU. Vi varetager bogføring, løn, årsregnskab og rådgivning, så du kan fokusere på din kerneforretning."
        path="/full-service"
      />
      <PageHero
        title="Full Service Løsninger"
        subtitle="Outsource din økonomi- og jurafunktion til os, og få frigivet tid til at fokusere på din kerneforretning."
        breadcrumbs={[{ name: 'Full service', href: '/full-service' }]}
      />

      <section className="py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold text-slate-900 mb-8">En komplet varetagelse</h2>
              <p className="text-lg text-slate-500 leading-relaxed mb-6">
                Med vores full service løsning fungerer vi som din eksterne økonomi- og juraafdeling. Vi tilpasser ydelserne til jeres specifikke behov og sikrer høj kvalitet og rettidighed i alle opgaver.
              </p>
              <p className="text-lg text-slate-500 leading-relaxed mb-10">
                Vi tager os af alt det administrative, så du kan fokusere på at vækste din virksomhed og skabe værdi for dine kunder uden bekymringer om compliance eller bogføring.
              </p>
              <div className="space-y-6">
                {fullServiceDetails.map((detail, idx) => (
                  <div key={idx} className="flex gap-4">
                    <div className="mt-1">
                      <CheckCircle2 className="h-6 w-6 text-[#876a57]" />
                    </div>
                    <div>
                      <h3 className="font-bold text-slate-900 mb-1">{detail.title}</h3>
                      <p className="text-slate-500">{detail.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-16 lg:mt-0 relative">
              <div className="aspect-[4/3] rounded-sm overflow-hidden bg-slate-100 shadow-2xl">
                <img
                  src="/images/office-desk-with-plant.png"
                  alt="Stilrent skrivebord med plante og bærbar computer"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Dark CTA Box */}
          <div className="bg-slate-900 rounded-sm p-12 lg:p-16 text-center shadow-lg relative overflow-hidden">
             <div className="absolute inset-0 z-0">
                <img
                  src="/images/consultation.png"
                  alt="Background"
                  className="w-full h-full object-cover opacity-10 grayscale mix-blend-multiply"
                />
             </div>
             <div className="relative z-10">
                <h3 className="text-2xl font-bold text-white mb-6">Få skræddersyet en pakke</h3>
                <p className="text-slate-300 mb-10 max-w-2xl mx-auto">
                  Lad os sammensætte en aftale, der matcher din virksomheds præcise behov for administrativ, økonomisk og juridisk support.
                </p>
                <Link to="/kontakt?emne=full-service" className="cta-button">
                  Kontakt FINANJU
                </Link>
             </div>
          </div>
        </div>
      </section>
    </main>
  );
}
